import { createSlice } from '@reduxjs/toolkit'

const catalogSlice = createSlice({
  name: 'catalog',
  initialState: {
    eventsType: [],
    ecoScoreDecode: []
  },
  reducers: {
    setEventsType (state, action) {
      state.eventsType = action.payload
    },
    setEcoScoreDecode (state, action) {
      state.ecoScoreDecode = action.payload
    }
  }
})

export const catalogActions = catalogSlice.actions
export default catalogSlice.reducer
